const createShippingMethodId = () => `shipping_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;

export function normalizeShippingMethods(value) {
  const rawMethods = Array.isArray(value) ? value : [];
  const seenIds = new Set();

  return rawMethods
    .map((method) => {
      const id = String(method?.id || method?.name || "").trim().toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_+|_+$/g, "");
      const name = String(method?.name || "").trim();
      const duration = String(method?.duration || "").trim();
      const price = Number(method?.price);

      if (!id || !name || !duration || seenIds.has(id) || !Number.isFinite(price) || price < 0) {
        return null;
      }

      seenIds.add(id);
      return {
        id,
        name,
        duration,
        price,
      };
    })
    .filter(Boolean);
}

export function createShippingMethod() {
  return {
    id: createShippingMethodId(),
    name: "",
    duration: "",
    price: "0",
  };
}
